module.exports = __webpack_public_path__ + "static/img/teseImg.2bae595d.jpg";